// import '../scss/main.scss'
import { createApp } from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSelect from 'vue-select'

import Alert from './apps/Alert'
import HeaderSearch from './apps/HeaderSearch'
import VimeoVideo from './apps/VimeoVideo'
import SearchPage from './apps/SearchPage'

import * as Bootstrap from 'bootstrap'
import ToggleActive from './components/toggle-active'
import Header from './components/header'
import Accordion from './components/accordion'
import UserForm from './components/userform'
import FlipImage from './components/flip-image'
import Form from './components/form'
import PageBanner from './components/page-banner'
import Share from './components/share'
import SideNav from './components/side-nav'
import { ImageLightbox } from './components/image-lightbox.js'

import '../scss/main.scss';

// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

document.addEventListener('DOMContentLoaded', () => {
  ToggleActive()
  Header()
  Accordion()
  UserForm()
  FlipImage()
  Form()
  PageBanner()
  Share()
  SideNav()
  ImageLightbox()
})

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
}

if (document.getElementById('search-custom-app')) {
  const appEl = document.getElementById('search-custom-app')
  const pageSize = appEl.getAttribute('data-size')
  const multiple = appEl.getAttribute('data-multiple')
  const notLast = appEl.getAttribute('data-notLast')

  const searchPage = createApp(SearchPage, { pageSize: parseInt(pageSize), multiple: !!multiple, notLast: !!notLast })

  searchPage.use(VueAxios, axios)
  searchPage.component('VSelect', VueSelect)
  searchPage.mount('#search-custom-app')
}

if (document.getElementById('alert')) {
  const alert = createApp(Alert)

  alert.use(VueAxios, axios)
  alert.mount('#alert')
}

if (document.getElementById('hero-video-wrapper')) {
  const video = createApp(VimeoVideo);

  video.mount('#hero-video-wrapper');
}

if (document.getElementById('header-search')) {
  const headerSearch = createApp(HeaderSearch)

  headerSearch.mount('#header-search')
}

